import axios from 'axios';
import store from '~/store';
import router from '~/router';

const api = axios.create({
    baseURL: appConfig.baseApiUrl,
    timeout: 1000,
    headers: {
        'X-Custom-Api-Client': 'api',
    }
});

api.interceptors.request.use(
    (config) => {
        let token = store.state.auth.token;
        let skipPaths = ['/auth-by-code']

        var a = document.createElement('a');
        a.href = config.url;
        // console.log(a.pathname);

        if (token && !skipPaths.includes(a.pathname)) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        return config;
    },

    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(function (response) {
    //console.log('DEBUG: RESPONSE: ', response);
    return response;
}, function (error) {
    // @note error.config, error.request, error.response
    // @note error.response: "data", "status", "statusText", "headers", "config", "request"
    //console.log('DEBUG: ERROR: ', );

    let message = error.response.data.error || error.response.data.message;

    if (error.response.status == 401) {
        //store.dispatch('authByCode');
        store.commit('setAuthToken', '');
    }

    if (error.response.status == 400 && message == 'token_not_provided') {
        console.log('REDIRECT');
        router.push('/');
    }

    return Promise.reject(error);
});

export default api;
